import { render, staticRenderFns } from "./sw-forgot-username.vue?vue&type=template&id=e76b36ae&scoped=true&"
import script from "./sw-forgot-username.vue?vue&type=script&lang=ts&"
export * from "./sw-forgot-username.vue?vue&type=script&lang=ts&"
import style0 from "./sw-forgot-username.vue?vue&type=style&index=0&id=e76b36ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e76b36ae",
  null
  
)

export default component.exports